<template>
  <div>
    <div v-if="types_module.length <= 0" class="d-flex justify-center">
      <v-icon
          :disabled="!edit_mode"
          @click.stop="dialog_visible = !dialog_visible"
          size="20px"
      >
        fa fa-question-circle
      </v-icon>
    </div>
    <div
        v-else
    >
      <v-chip-group column>
        <v-chip
            :disabled="!edit_mode"
            @click.stop="dialog_visible = !dialog_visible"
            v-for="(type_lecture, index) in types_module" :key="index"
            outlined
        >
          {{ type_lecture }}
        </v-chip>
      </v-chip-group>
    </div>
    <v-dialog
        content-class="rounded-xl"
        v-model="dialog_visible"
        width="400"
    >
      <v-card>
        <v-card-title>
          <v-row no-gutters>
            <v-col cols="12" class="d-flex justify-end">
              <v-btn
                  icon
                  @click="closeDialog()"
              >
                <v-icon size="20">
                  fa-times
                </v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" class="d-flex justify-center text-h5">
              Редактирование модуля
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <table class="my-8 mx-auto text-subtitle-1">
            <tr>
              <td class="d-flex align-start pe-4">Название модуля:</td>
              <td>
                <strong>{{ module_name }}</strong>
              </td>
            </tr>
            <tr>
              <td class="d-flex align-start pt-4">Тип модуля:</td>
              <td>
                <strong>{{ header_name }}</strong>
              </td>
            </tr>
          </table>
          <div class="d-flex justify-center align-center">
            <v-select
                v-model="selected_types_module"
                :items="setListTypeModule"
                :menu-props="{ top: true, offsetY: true }"
                item-text="type_name"
                :value="types_module"
                label="Типы работ модуля"
                hide-details
                clearable
                outlined
                multiple
                rounded
                dense
            >
              <template v-slot:item="{ item }">
                {{ item.type_name + ` (${item.description})` }}
              </template>
            </v-select>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
              class="mx-auto rounded-xl"
              @click="updateTypesModule()"
              color="teal"
              outlined
          >
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from "lodash"

export default {
  name: "EditDialogFieldDataTable",
  props: {
    module: {
      type: Object
    },
    types_module: {
      type: Array
    },
    header_name: {
      type: String
    },
    edit_mode: {
      type: Boolean
    },
    types_module_flag: {
      type: String
    }
  },
  data: () => ({
    types_lecture: [
      {type_name: 'Не предусмотрено', description: 'Не предусмотрено'},
      {type_name: 'АЛ', description: 'Аудиолекция'},
      // {type_name: 'АФ', description: 'Аудиофайл'},
      {type_name: 'ВКС', description: 'Видеоконференция'},
      {type_name: 'ВЛ', description: 'Видеолекция'},
      {type_name: 'ТФ', description: 'Традиционная форма'},
      // {type_name: 'ВФ', description: 'Видеофайл'},
      // {type_name: 'ВЭБ', description: 'Вебинар'},
      // {type_name: 'ДМ', description: 'Дополнительный материал'}
    ],
    types_practical_training: [
      {type_name: 'Не предусмотрено', description: 'Не предусмотрено'},
      {type_name: 'АФ', description: 'Аудиофайл'},
      {type_name: 'ВКС', description: 'Видеоконференция'},
      {type_name: 'ВФ', description: 'Видеофайл'},
      // {type_name: 'ВЭБ', description: 'Вебинар'},
      // {type_name: 'ДМ', description: 'Дополнительный материал'},
      {type_name: 'ПЗ', description: 'Практическое занятие'},
      // {type_name: 'С', description: 'Семинар'},
      {type_name: 'ТФ', description: 'Традиционная форма'},

    ],
    types_laboratory_work: [
      {type_name: 'Не предусмотрено', description: 'Не предусмотрено'},
      {type_name: 'АФ', description: 'Аудиофайл'},
      {type_name: 'БД', description: 'База данных'},
      {type_name: 'ВКС', description: 'Видеоконференция'},
      {type_name: 'ВФ', description: 'Видеофайл'},
      // {type_name: 'ДМ', description: 'Дополнительный материал'},
      {type_name: 'ЛР', description: 'Лабораторная работа'},
      {type_name: 'ТФ', description: 'Традиционная форма'},
    ],
    types_students_independent_work: [
      {type_name: 'Не предусмотрено', description: 'Не предусмотрено'},
      {type_name: 'БД', description: 'База данных'},
      {type_name: 'ДМ', description: 'Дополнительный материал'},
      {type_name: 'РЗ', description: 'Решение задач'}
    ],
    types_final_control: [
      {type_name: 'Не предусмотрено', description: 'Не предусмотрено'},
      {type_name: 'ВКС', description: 'Видеоконференция'},
      {type_name: 'ВСЛ', description: 'Вопросы самоконтроля лекции'},
      {type_name: 'Г', description: 'Глоссарий'},
      {type_name: 'ГР', description: 'Графическая работа'},
      {type_name: 'Д', description: 'Дебаты'},
      {type_name: 'ДП', description: 'Дневник практики'},
      {type_name: 'ИЗ', description: 'Индивидуальное задание'},
      {type_name: 'ИНЗ', description: 'Интерактивное задание'},
      {type_name: 'ИП', description: 'Индивидуальный проект'},
      {type_name: 'КВ', description: 'Контрольные вопросы'},
      {type_name: 'КЗ', description: 'Кейс-задание'},
      {type_name: 'КОНР', description: 'Контрольная работа'},
      {type_name: 'КП', description: 'Курсовой проект'},
      {type_name: 'КР', description: 'Курсовая работа'},
      {type_name: 'ЛЗД', description: 'Лабораторное задание'},
      {type_name: 'О', description: 'Опрос'},
      {type_name: 'ОТ', description: 'Отчёт'},
      {type_name: 'П', description: 'Презентация'},
      {type_name: 'ПЗД', description: 'Практическое задание'},
      {type_name: 'Р', description: 'Реферат'},
      {type_name: 'РГР', description: 'Расчетно-графическая работа'},
      {type_name: 'РЗ', description: 'Решение задач'},
      {type_name: 'СЗ', description: 'Ситуационная задача'},
      {type_name: 'Т', description: 'Тест'},
      {type_name: 'ТЗ', description: 'Творческое задание'},
      {type_name: 'ТФ', description: 'Традиционная форма'},
      {type_name: 'Э', description: 'Эссе'},
    ],
    // list_type_module: [
    //     {type_name: 'ЛР', description: 'Лабораторная работа'},
    //     {type_name: 'ОК', description: 'Онлайн консультация'},
    //     {type_name: 'ДМС', description: 'Демонстрационный материал'},
    //     {type_name: 'ВО', description: 'Видеообзор'},
    //     { type_name: 'АР', description: 'Аудиторная работа со студентами' },
    //     { type_name: 'ВЗЛ', description: 'Визуальная лаборатория' },
    //     { type_name: 'БД', description: 'База данных' },
    //     { type_name: 'КЛ', description: 'Конспект лекции' },
    //     { type_name: 'РТ', description: 'Рабочая тетрадь' },
    //     { type_name: 'ЧС', description: 'Чат-семинар' },
    //     { type_name: 'ЛС', description: 'Личное сообщение' },
    //     { type_name: 'W', description: 'Вики' },
    //     { type_name: 'Ф', description: 'Форум' },
    // ],
    selected_types_module: [],
    dialog_visible: false,
    dialog: false,
    headers_table: [
      {
        text: 'НАЗВАНИЕ ТИПА РАБОТЫ',
        value: 'type_name',
        sortable: false,
        align: "center",
        filterable: false,
        divider: true
      },
      {text: 'РАСШИФРОВКА', value: 'description', align: "center", sortable: false, filterable: false},
    ],
  }),
  computed: {
    module_name() {
      return this.module?.name
    },
    setListTypeModule() {
      if (this.types_module_flag === 'types_lecture') {
        return this.types_lecture
      }
      if (this.types_module_flag === 'types_practical_training') {
        return this.types_practical_training
      }
      if (this.types_module_flag === 'types_laboratory_work') {
        return this.types_laboratory_work
      }
      if (this.types_module_flag === 'types_students_independent_work') {
        return this.types_students_independent_work
      }
      if (this.types_module_flag === 'types_final_control') {
        return this.types_final_control
      }
    },

  },
  methods: {
    updateTypesModule() {
      this.dialog_visible = !this.dialog_visible
      this.dialog = false
      this.$emit('updateTypesModule', {
        selected_types_module: this.selected_types_module
      })
    },
    closeDialog() {
      this.dialog_visible = false
      this.dialog = false
    }
  },
}
</script>

<style scoped>
>>> .dialog-right {
  position: absolute;
  top: 0;
  right: 0;
}
</style>